import { createApiClient, getAuthHeaders } from "@/lib/api-client";
import type { AssistantSuccess } from "@/lib/assistant-contract";

import {
  ModelSelectionResponse,
  ModelUpdateResponse,
  parseWire,
  SetModelBody,
} from "./model-selection-wire";

/** The model this assistant instance answers with, and the models it accepts. */
export type ModelConfig = AssistantSuccess<"getModel">["data"];

export type AvailableModel = ModelConfig["availableModels"][number];

/** What switching the model answers. */
export type ModelUpdate = AssistantSuccess<"setModel">["data"];

const assistantApi = createApiClient({
  baseUrl: import.meta.env.VITE_API_URL
    ? `${import.meta.env.VITE_API_URL}/assistant`
    : "http://localhost:3200/assistant",
  getAuthHeaders,
});

export async function fetchModelConfig(): Promise<ModelConfig> {
  const answer = await assistantApi.get<unknown>("/config/model");
  return parseWire(ModelSelectionResponse, answer, "The model configuration").data;
}

export async function updateModelSelection(modelId: string): Promise<ModelUpdate> {
  const body = parseWire(SetModelBody, { modelId }, "The model change");
  const answer = await assistantApi.put<unknown>("/config/model", body);
  return parseWire(ModelUpdateResponse, answer, "The model change's answer").data;
}
